<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close"></div>
      <div class="modalContent" id="confetti">
        <div class="cEl" id="el1"></div>
        <div class="cEl" id="el2"></div>
        <div class="cEl" id="el3"></div>
        <div class="cEl" id="el4"></div>
        <div class="cEl" id="el5"></div>
        <div class="confetti-1"></div>
        <div class="confetti-2"></div>
        <div class="close" v-on:click="close"></div>
        <h4>Selamat <b>{{$session.get('tufi2_name')}}</b></h4>
        <p>Selamat ya, kamu telah berhasil mendapatkan satu bibit pohon yang
          akan kami tanam untuk kamu. Terima kasih sudah team up untuk
          menyelamatkan Bumi. Tunggu kabar selanjutnya ya.</p>
        <button class="secondary" v-on:click="close">Tutup</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      next: null,
    };
  },
  methods: {
    open(d, next) {
      this.next = next;
      this.show = true;
      setTimeout(() => {
        party.confetti(document.getElementById('el1'));
        party.confetti(document.getElementById('el2'));
        party.confetti(document.getElementById('el3'));
      });
      setTimeout(() => {
        party.confetti(document.getElementById('el2'));
        party.confetti(document.getElementById('el5'));
      }, 500);
      setTimeout(() => {
        party.confetti(document.getElementById('el4'));
        party.confetti(document.getElementById('el5'));
      }, 700);
      setTimeout(() => {
        party.confetti(document.getElementById('el3'));
      }, 1000);
      setTimeout(() => {
        party.confetti(document.getElementById('el5'));
      }, 2000);
      setTimeout(() => {
        party.confetti(document.getElementById('el2'));
        party.confetti(document.getElementById('el3'));
        party.confetti(document.getElementById('el4'));
      }, 3000);
      setTimeout(() => {
        party.confetti(document.getElementById('el1'));
        party.confetti(document.getElementById('el5'));
      }, 5000);
      setTimeout(() => {
        party.confetti(document.getElementById('el2'));
      }, 6000);
      setTimeout(() => {
        party.confetti(document.getElementById('el3'));
      }, 7000);
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 9997;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 140px 60px 120px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      max-width: 400px;
      background-size: 180px auto;
      background-position: right bottom;
      background-repeat: no-repeat;
      text-align: center;
      overflow: hidden;
      background-color: #e6e1c1;
      .btn{
        position: relative;
        z-index: 9;
        padding: 0 16px;
        font-size: 16px;
        height: 45px;
        line-height: 45px;
        display: inline-block;
        text-decoration: none;
        &:hover{
          color: #fff;
        }
      }
      .cEl{
        position: absolute;
        width: 20px; height: 20px;
        &#el1{
          left: 20px; top: 20px;
        }
        &#el2{
          left: 100px; top: 100px;
        }
        &#el3{
          left: 50%; top: 50%;
        }
        &#el4{
          right: 20px; top: 50px;
        }
        &#el5{
          right: 20px; bottom: 40px;
        }
      }
      .close{
        width: 36px; height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/close.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .7;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: rgba(0,0,0,.2);
          opacity: .6;
        }
      }
      @media (max-width: 680px) {
        width: calc(100% - 20px);
        box-sizing: border-box;
        padding: 80px 30px;
      }
      img{
        max-width: 100%;
        position: relative;
        z-index: 9;
      }
      h4{
        margin: 0 0 10px;
        font-size: 24px;
        font-weight: normal;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        position: relative;
        z-index: 3;
      }
      p{
        margin: 0 0 24px;
        font-size: 16px;
        position: relative;
        z-index: 3;
        b{
          color: #5351a4;
          font-family: GolosUIWebBold,sans-serif;
          span{
            color: #f14724;
          }
        }
      }
      button{
        position: relative;
        z-index: 9;
        background: none;
        border: none;
        box-shadow: none;
        font-size: 18px;
      }
      .confetti-1{
        position: absolute;
        left: 0; top: 0; right: 0; bottom: 0;
        background-image: url(../assets/confetti-1.png);
        background-position: top center;
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
      .confetti-2{
        position: absolute;
        left: 0; top: 0; right: 0; bottom: -20px;
        background-image: url(../assets/confetti-2.png);
        background-position: bottom center;
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
      .modalAction{
        margin: 30px -40px -30px;
        padding: 10px 20px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        @media (max-width: 680px) {
          margin: 30px -16px -30px;
        }
        .btn{
          margin-left: 10px;
          padding-top: 6px; padding-bottom: 6px;
        }
      }
    }
  }
</style>
